import { ThemeProvider } from "styled-components";
import { useState } from "react";
import { darkTheme } from "./utils/Themes.js";
import Navbar from "./components/Navbar";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import FeaturedProject from "./components/FeaturedProject";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import ProfessionalCertificates from "./components/ProfessionalCertificates";
import Certificates from "./components/Certificates";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Education from "./components/Education";
import styled from "styled-components";

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
`;

const Wrapper = styled.div`
  background:
    linear-gradient(38.73deg, rgba(204, 0, 187, 0.12) 0%, rgba(201, 32, 184, 0) 50%),
    linear-gradient(141.27deg, rgba(0, 70, 209, 0) 50%, rgba(0, 70, 209, 0.12) 100%);
  width: 100%;
`;

function App() {
  const [darkMode] = useState(true);

  return (
    <ThemeProvider theme={darkTheme}>
      <Router>
        <Navbar />
        <Body data-theme={darkMode ? "dark" : "light"}>
          <HeroSection />
          <FeaturedProject />
          <Experience />
          <Skills />
          <ProfessionalCertificates />
          <Certificates />
          <Wrapper>
            <Education />
            <Contact />
          </Wrapper>
          <Footer />
        </Body>
      </Router>
    </ThemeProvider>
  );
}

export default App;
